import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import CreateProduct from '../components/CreateProduct';
import PostsList from '../components/PostsList';
import { checkAuth } from '../redux/actions';

export default function Admin() {
  const dispatch = useDispatch();
  const { id } = useParams();
  let content = null;

  useEffect(() => {
    dispatch(checkAuth.setCurrentPage('dashboard'));
    return () => {
      dispatch(checkAuth.setCurrentPage('public'));
    }
  }, [dispatch]);

  switch (id) {
    case 'posts':
      content = <PostsList />;
      break;
    case 'create':
    case 'update':
      content = <CreateProduct />;
      break;
    default:
      content = null;
      break;
  }

  return (
    <>
      <ul className="nav nav-tabs justify-content-center pt-2 bg-primary">
        <li className="nav-item">
          <NavLink
            to="/admin/dashboard/posts"
            className="nav-link fw-bold text-white"
            activeClassName="active">Posts</NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/admin/dashboard/create"
            className="nav-link fw-bold text-white"
            activeClassName="active">Create Post</NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/admin/dashboard/update"
            className="nav-link fw-bold text-secondary disabled"
            activeClassName="active">Update Post</NavLink>
        </li>
        <li><a href="/" target="_blank" className="btn btn-sm btn-primary view-web">View Website</a></li>
      </ul>
      {content}
    </>
  );
}